import * as Dropzone from 'react-dropzone'
import { typeIgnorantIncludes } from '../../.../../../../../utils/arrays'
import { formatBytes } from '../../../../../utils/bytes'
import { getFileExtension } from '../../../../../utils/files'
import { FileError, FileErrorType } from '../../../../../utils/forms'

type FileType = 'audio/wav' | 'als' | 'flp'

export const useFilePicker = ({
  maxFileSizeBytes,
  acceptedFileTypes,
  onDropAccepted,
  onDropRejected,
  restrictAcceptedFiles
}: {
  maxFileSizeBytes: number
  acceptedFileTypes: FileType[]
  onDropAccepted: (file: File) => void
  onDropRejected: (fileErrors: FileError[]) => void
  restrictAcceptedFiles?: boolean
}) => {
  const { getRootProps, getInputProps } = Dropzone.useDropzone({
    accept: restrictAcceptedFiles ? acceptedFileTypes : undefined,
    multiple: false,
    maxSize: maxFileSizeBytes,
    onDropAccepted: (files) => {
      onDropAccepted(files[0])
    },
    onDropRejected: (fileRejections: Dropzone.FileRejection[]) => {
      const file = fileRejections[0].file
      const fileErrors: FileError[] = []

      if (file.size > maxFileSizeBytes) {
        fileErrors.push({
          type: FileErrorType.SIZE,
          message: `File size cannot exceed ${formatBytes(maxFileSizeBytes)}`
        })
      }

      const type = getFileExtension(file)
      if (!typeIgnorantIncludes(acceptedFileTypes, type)) {
        fileErrors.push({
          type: FileErrorType.SIZE,
          message:
            acceptedFileTypes.length > 1
              ? `File type must be one of: ${acceptedFileTypes.join(', ')}`
              : `File type must be ${acceptedFileTypes[0]}`
        })
      }

      onDropRejected(fileErrors)
    },
    validator: (file) => {
      if (!typeIgnorantIncludes(acceptedFileTypes, file.type || getFileExtension(file))) {
        return {
          code: 'ext',
          message: `Extension not allowed`
        }
      }

      return null
    }
  })

  return { getRootProps, getInputProps }
}
